// extracted by mini-css-extract-plugin
export default {"resetPasswordForm":"ResetPasswordForm_resetPasswordForm__9w2r7","hover":"ResetPasswordForm_hover__e6ZUF"};